// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1QI3w","title":"ClientInsurance_title__1Z_PW","itemText":"ClientInsurance_itemText__28-H3"};